(function () {
    'use strict';
    angular.module('wamasysApp').config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        $stateProvider.state('windows-preparation', {
            parent: 'account', url: '/windows-preparation',
            data: {authenticate: true, pageTitle: 'windowsPreparation.title'},
            views: {'content@': {templateUrl: 'app/account/windows-preparation/windows-preparation.html', controller: 'WindowsPreparationController', controllerAs: 'vm'}},
            resolve: {translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('windowsPreparation');
                return $translate.refresh();
            }]}
        });
    }
})();
